// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const nit: CountryValidator<"CO"> = createValidator(
  "co.nit",
  38,
);

export default nit;
export const compact = nit.compact;
export const format = nit.format;
export const validate = nit.validate;
export const generate = (): string =>
  nit.generate?.() ??
  (() => {
    throw new Error(
      "Validator co.nit cannot generate values",
    );
  })();
